import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ReportsService } from "../../consumer-report/reports.service";
import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-payment-report-smart',
  template: `<app-payment-report [payments]="payments" [summary]="summary" [startDate]="startDate" [endDate]="endDate"></app-payment-report>`,
  styles: [
  ]
})
export class PaymentReportSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  payments: any =[];
  summary: any = [];
  startDate;
  endDate;

  constructor(private reportsService: ReportsService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()

    var dt = new Date();
    let curdate = new Date().getFullYear().toString() +'-'+(new Date().getMonth() + 1).toString()+'-01';
    this.endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.startDate = formatDate(curdate, 'yyyy-MM-dd', 'en');
    let params: any = new HttpParams().set('startDate', this.startDate).set('endDate', this.endDate )


    this.reportsService.getConsumerPaymentSummary(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
        console.log('summary data',this.summary)
      }
    })    
	
    this.reportsService.getConsumerPayments(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.payments=resData;
      }
    })
	}

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  
}
